import React from 'react'
import PropTypes from 'prop-types'

import ListLoader from '../../ListLoader'

function Actions({
  totalPages, currentPage, onLoadMoreClick, openReviewModal,
}) {
  return (
    <div>
      <ListLoader
        totalPages={totalPages}
        currentPage={currentPage}
        onShowMore={onLoadMoreClick}
        buttonClass="btn btn-outline-default u-mr10"
        text="Show more reviews"
      />
      <button className="btn btn-primary" onClick={openReviewModal}>Leave a review</button>
    </div>
  )
}

Actions.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onLoadMoreClick: PropTypes.func.isRequired,
  openReviewModal: PropTypes.func.isRequired,
}

export default Actions
